export default __webpack_public_path__ + "static/media/icons8-csv.5e57f850.svg";